import { toast } from "react-toastify";
import { postAPI } from "./api.service";

export const getUserSessionDetails = () => {
  return JSON.parse(localStorage.getItem('user') || '{}') as { id?: string, accessToken?: string, email?: string, firstname?: string, lastname?: string, role?: string };
}

export async function exportResponses(format: 'csv' | 'excel' | 'pdf', userId: string, phase: any, search: string) {
  try {
    if (!userId) {
      toast.error('User not logged in');
      return;
    }
    // Build query params - match what useFetchResponsesForAdmin uses
    const params: any = {
      userId,
      phase,
      format
    };
    if (search) params.search = search;

    // create query string
    const qs = new URLSearchParams();
    Object.keys(params).forEach(k => {
      const v = (params as any)[k];
      if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
    });

    const url = `http://localhost:4000/api/book-review/review-response/group/phase-wise-responses/export?${qs.toString()}`; // adjust base path if needed

    const resp = await fetch(url, {
      method: 'GET',
      headers: {
        // include auth headers if required
        'Accept': '*/*'
      }
    });

    if (!resp.ok) {
      const json = await resp.json().catch(() => null);
      throw new Error(json?.error || json?.message || `Export failed with status ${resp.status}`);
    }

    const blob = await resp.blob();
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    let ext = 'csv';
    let mime = 'text/csv';
    if (format === 'excel') { ext = 'xlsx'; mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; }
    else if (format === 'pdf') { ext = 'pdf'; mime = 'application/pdf'; }

    // Create filename similar to server
    const filename = `participants_export_${timestamp}.${ext}`;

    // Download client-side
    const urlBlob = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(urlBlob);
  } catch (err: any) {
    console.error('Export error', err);
    toast.error(err?.message || 'Export failed');
  }
}

export const logout = async () => {
  try {
    const res = await postAPI('auth/logout', { userId: JSON.parse(String(localStorage.getItem('user')))?.id, accessToken: JSON.parse(String(localStorage.getItem('user')))?.accessToken });
    if (res.status === 200) {
      // localStorage.clear();
      localStorage.removeItem('user');
      localStorage.removeItem('login');
      
      window.location.href = '/login';
      return true;
    } else
      return false;
  } catch (err) {
    console.error('Logout error', err);
  }
}